/*eslint default-case: "off"*/
import moment from 'moment';
import colors from '../colors';

const getStartTime = selectedFilter => {
  let startTime = moment().startOf('day');

  switch (selectedFilter) {
    case 'Last year':
      startTime = startTime.subtract(1, 'years');
      break;

    case 'Last 6 months':
      startTime = startTime.subtract(6, 'months');
      break;

    case 'Last 3 months':
      startTime = startTime.subtract(3, 'months');
      break;

    case 'Last month':
      startTime = startTime.subtract(1, 'months');
      break;

    case 'Last week':
      startTime = startTime.subtract(1, 'weeks');
      break;
  }

  return startTime;
};

const formatData = data => {
  const dataSorted = data.sort((a, b) => new moment(a.date).format('YYYYMMDD') - new moment(b.date).format('YYYYMMDD'));
  return dataSorted.map(d => {
    return {
      date: moment(d.date).format('DD.MM.YYYY'),
      value: d.value
    };
  });
};

export const getTimeFilteredData = (data, selectedFilter) => {
  if (selectedFilter === 'All time') return formatData(data);
  let filteredData = data.filter(d => {
    return moment(d.date).format('x') > getStartTime(selectedFilter).format('x');
  });
  return formatData(filteredData);
};
export const chartColors = [colors['purple-600'], colors['blue-300'], colors['purple-500'], colors['blue-500'], colors['purple-400'], colors['blue-700'], colors['purple-700'], colors['green-500'], colors['blue-400'], colors['green-700'], colors['purple-800'], colors['green-800'], colors['blue-800'], colors['purple-900'], colors['green-600'], colors['blue-900']];
export const calculatePercentages = data => {
  const total = data.reduce((prev, next) => prev + next.value, 0);
  let newData = data.map(item => ({ ...item,
    total,
    percentage: item.value / total * 100
  }));
  newData = newData.sort((a, b) => b.value - a.value);
  return newData;
};